<div class="bg-white rounded shadow">
  <div class="profile-edit-box m-4">
    <div class="d-flex align-items-center">
      <app-search (onValueChange)="onSearchChange($event)"></app-search>
      <div class="flex-fill"></div>
      <app-button (onChangeClick)="onAdd()">{{ 'create_template' | translate }}</app-button>
    </div>
    @if (isLoader) {
      <div class="d-flex justify-content-center">
        <app-loader size="small"></app-loader>
      </div>
    } @else {
      @if (dataSource$ | async; as dataSource) {
        <app-table
          class="w-100"
          [dataSource]="dataSource"
          [visibleColumnKeys]="visibleColumns"
          (onSortChange)="onSortChange($event)"
          (onPaginationChange)="onPaginationChange($event)"
          (menuSelected)="onActionChange($event)"
        ></app-table>
      }
    }
  </div>
</div>
